import { MedalIcon, type MedalTier } from './MedalIcon'

export interface TrophyCabinetItem {
  id: string
  label: string
  sublabel?: string
  tier: MedalTier
  highlight?: boolean
}

// Glass display cabinet with shelf rows — the palmarés showcase.
export function TrophyCabinet({ items }: { items: TrophyCabinetItem[] }) {
  return (
    <div className="trophy-cabinet tx-glass-sheen">
      {items.map((item) => (
        <div key={item.id} className={`trophy-shelf${item.highlight ? ' highlight' : ''}`}>
          <MedalIcon tier={item.tier} size={34} />
          <div style={{ minWidth: 0 }}>
            <div className="trophy-shelf-label">{item.label}</div>
            {item.sublabel && <div className="trophy-shelf-sublabel">{item.sublabel}</div>}
          </div>
        </div>
      ))}
    </div>
  )
}
